import { breadcrumbTranslation } from 'components/layout/Breadcrumb/utils';
import { BreadcrumbsRoute } from 'use-react-router-breadcrumbs';

export const assetsOverviewRoutes: BreadcrumbsRoute = {
  path: 'assets',
  breadcrumb: breadcrumbTranslation('assets'),
  children: [
    {
      index: true,
      lazy: () => import('pages/Assets'),
    },
    {
      path: 'location',
      breadcrumb: breadcrumbTranslation('assets-locations'),
      lazy: () => import('pages/Assets/AssetLocation'),
    },
  ],
};
